//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { GalleriesClientType } from '@galleries/selectors/getGalleriesClientType';

export enum Plurality {
  singular = 'singular',
  plural = 'plural',
  default = 'default'
}

// By default, use the product name: "Galleries" 
//  For referring to the feature/product offering.
//
// Pluralize: "Galleries" 
//  For referring to multiple galleries.
//
// Singularize: "Gallery"
//  For referring to a single gallery
export const getFeatureNames = (feature: GalleriesClientType): Record<Plurality, string> => {
  switch (feature) {
    case GalleriesClientType.instashop: {
      return {
        singular: 'InstaShop',
        plural: 'InstaShops',
        default: 'InstaShop',
      };
    }
    case GalleriesClientType.custom:
    case GalleriesClientType.galleries: {
      return {
        singular: 'Gallery',
        plural: 'Galleries',
        default: 'Galleries',
      };
    }
    case GalleriesClientType.none:
      return {
        singular: '',
        plural: '',
        default: '',
      };
  }
};
